// import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import AddBlog from '../components/Admin/Blog/AddBlog';
import Coupon from '../components/Admin/coupon/Coupon';
import BlogAdmin from '../components/Admin/Blog/BlogAdmin';
import Branches from '../components/Admin/Branches/Branches';
import Promotion from '../components/Admin/promotion/Promotion';
import FlashSale from '../components/Admin/FlashSale/FlashSale';
import AdminIndex from '../components/Admin/AdminIndex/AdminIndex';
import AdminPedidos from '../components/Admin/Pedidos/AdminPedidos';
import ResponsiveDrawer from '../components/Admin/ResponsiveDrawer';
import ShopSort from '../components/Admin/Product/Sorting/ShopSort';
import AdminContact from '../components/Admin/Contact/AdminContact';
import BannersShop from '../components/Admin/BannersShop/BannersShop';
import BlogUpdate from '../components/Admin/Blog/BlogUpdate/BlogUpdate';
import NewBranch from '../components/Admin/Branches/NewBranch/NewBranch';
import CouponSave from '../components/Admin/coupon/couponSave/CouponSave';
import NewProduct from '../components/Admin/Product/NewProduct/NewProduct';
import AbandonedCart from '../components/Admin/AbandonedCart/AbandonedCart';
import BrandContainer from '../components/Admin/Product/Brand/BrandContainer';
import AdminsUsersList from '../components/Admin/admin-users/AdminsUsersList';
import ProductList from '../components/Admin/Product/ProductList/ProductList';
import AdminDirectory from '../components/Admin/AdminDirectory/AdminDirectory';
import ProductReviews from '../components/Admin/ProductReviews/AdminProductReviews';
import DashboardComponent from '../components/Admin/Dashboard/DashboardComponent';
import AddFlashSale from '../components/Admin/FlashSale/AddFlashSale/AddFlashSale';
import ShippingMethods from '../components/Admin/shipping-methods/ShippingMethods';
import OdooProductList from '../components/Admin/Product/OdooProduct/OdooProductList';
import NewDirectory from '../components/Admin/AdminDirectory/NewDirectory/NewDirectory';
import PedidosIncompletos from '../components/Admin/UnfinishedOrders/PedidosIncompletos';
import ProductQualities from '../components/Admin/Product/ProductQualities/ProductQualities';
import MedicalCoupons from '../components/Admin/MedicalCoupons/MedicalCoupons';
import MedicalOrders from '../components/Admin/MedicalOrders/MedicalOrders';
import MedicalSummary from '../components/Admin/MedicalOrders/MedicalSummary';
import Clients from '../components/Admin/Clients/Clients';
import CustomerDetail from '../components/Admin/Clients/CustomerDetail';

// import ProductTools from '../components/Admin/Tools/ProductTools';
// import AccountEmail from '../components/Admin/Clients/AccountEmail';
// import ProductLoad from '../components/Admin/Product/ProductLoad/ProductLoad';

export const AdminRoutes = () => {
    // useEffect(() => {
    //     window.zE('webWidget', 'hide');
    // }, []);

    return (
        <>
            <ResponsiveDrawer />
            <Routes>
                <Route path="/" element={<AdminIndex />} />
                <Route path="/dashboard" element={<DashboardComponent />} />
                <Route path="/clientes" element={<Clients />} />
                <Route path="/clientes/:id" element={<CustomerDetail />} />

                <Route path="/productos" element={<ProductList />} />
                <Route path='/producto-agregar' element={<NewProduct />} />
                <Route path="/productos-odoo" element={<OdooProductList />} />
                <Route path="/categorias-productos" element={<ProductQualities />} />
                <Route path='/marcas-productos' element={<BrandContainer />} />
                <Route path="/orden-productos" element={<ShopSort />} />
                <Route path="/comentarios-productos" element={<ProductReviews />} />

                <Route path="/pedidos" element={<AdminPedidos />} />
                <Route path="/pedidos-incompletos" element={<PedidosIncompletos />} />
                <Route path='/carrito-abandonado' element={<AbandonedCart />} />

                <Route path="/metodos-envio" element={<ShippingMethods />} />
                <Route path="/cupones" element={<Coupon />} />
                <Route path="/cupones/registrar" element={<CouponSave />} />
                <Route path="/cupones-medicos" element={<MedicalCoupons />} />
                <Route path="/pedidos-medicos" element={<MedicalOrders />} />
                <Route path="/resumen-medicos" element={<MedicalSummary />} />
                <Route path="/promociones" element={<Promotion />} />

                <Route path="/contacto" element={<AdminContact />} />
                {/* <Route path="/comentarios" element={<AdminContact />} /> */}

                <Route path="/admins" element={<AdminsUsersList />} />
                <Route path="/banners-tienda" element={<BannersShop />} />
                {/* <Route path="/tools" element={<ProductTools />} /> */}

                <Route path="/directorio-medico" element={<AdminDirectory />} />
                <Route path="/nuevo-medico" element={<NewDirectory />} />

                <Route path="/blog" element={<BlogAdmin />} />
                <Route path="/nuevo-blog" element={<AddBlog />} />
                <Route path="/actualizar-blog/:url" element={<BlogUpdate />} />

                <Route path="/sucursales" element={<Branches />} />
                <Route path="/nueva-sucursal" element={<NewBranch />} />
                
                {/* <Route path="/carga-masiva" element={<ProductLoad />} /> */}
                {/* <Route path="/correo-masivo" element={<AccountEmail />} /> */}
                
                <Route path="/ofertas-relampago" element={<FlashSale />} />
                <Route path="/nueva-oferta-relampago" element={<AddFlashSale />} />
                
                <Route path="*" element={<Navigate to="/nefro-admin" replace />} />
            </Routes>
        </>
    );
};
